module.exports = __webpack_public_path__ + "dc824e1a59f298cf5b21cf2425e28fd7.png";